import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DownloadTimestampService {
  private pageName?: string;
  private hours?: number;

  set(pageName: string, hours: number) {
    this.pageName = pageName;
    this.hours = hours;
  }

  get(pageName: string) {
    if (pageName !== this.pageName) return;
    const hours = this.hours;
    this.hours = undefined;
    this.pageName = undefined;
    return hours;
  }

  getDateRange(hours: number) {
    const now = new Date();
    const afterDTS = new Date(now.getTime() - hours * 60 * 60 * 1000).toISOString();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    const beforeDTS = tomorrow.toISOString();
    return { afterDTS, beforeDTS };
  }
}
